import {
  adminRoute,
  provinceRoute,
  restrictedRoute,
  rootRoute,
} from "./routes";
import { contactRoutes } from "@/pages/Contact/routes";
import { emergentSignInRoutes } from "@/pages/EmergentSignIn/routes";
import { feedbackRoutes } from "@/pages/Feedback/routes";
import { generalTermsRoutes } from "@/pages/GeneralTerms/routes";
import { indigenousRoutes } from "@/pages/Indigenous/routes";
import {
  orderConfirmRoute,
  orderRequestRoute,
  orderRoutes,
} from "@/pages/Order/routes";
import { selectProvinceRoutes } from "@/pages/SelectProvince/routes";
import { trainingRoutes } from "@/pages/Training/routes";
import { registerRoutes } from "@/pages/Register/routes";

export const routeTree = rootRoute.addChildren([
  provinceRoute,
  restrictedRoute,
  contactRoutes,
  emergentSignInRoutes,
  feedbackRoutes,
  generalTermsRoutes,
  indigenousRoutes,
  orderRoutes,
  orderRequestRoute,
  orderConfirmRoute,
  registerRoutes,
  selectProvinceRoutes,
  trainingRoutes,
  adminRoute,
]);
